import React from 'react';
import PropTypes, { InferProps } from 'prop-types';

const iconPropertyTypes = {
  dPath: PropTypes.string.isRequired,
  fill: PropTypes.string,
  focusable: PropTypes.bool,
  height: PropTypes.number,
  tabIndex: PropTypes.number,
  title: PropTypes.string,
  titleAccess: PropTypes.string,
  width: PropTypes.number,
};

type IconProperties = InferProps<typeof iconPropertyTypes> & {
  fill?: string;
  focusable?: boolean;
  height?: number;
  tabIndex?: number;
  width?: number;
  className?: string;
  titleAccess?: string;
};

const Icon = ({
  width = 24, height = 24, dPath, title, fill, className, titleAccess, ...rest
}: IconProperties) => (
  <svg
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...rest}
  >
    <title>{titleAccess ?? title}</title>
    <path d={dPath} fill={fill} />
  </svg>
);

const IconWithDefaults = ({
  width = 24, height = 24, dPath, title, fill, titleAccess, ...rest
}: IconProperties) => (
  <Icon
    dPath={dPath}
    title={title}
    titleAccess={titleAccess}
    width={width}
    height={height}
    fill={fill}
    focusable={false}
    aria-hidden="true"
    tabIndex={-1}
    {...rest}
  />
);

Icon.propTypes = iconPropertyTypes;
IconWithDefaults.propTypes = iconPropertyTypes;

export {
  Icon as default,
  IconWithDefaults,
};
